import React, { useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { DraggableFabricItem } from "./DraggableFabricItem";
import { FormLabel } from "@/components/ui/form";

interface Props {
  fabrics: any[];
  control: any;
  setValue: any;
}

export function DraggableFabricList({ fabrics, control, setValue }: Props) {
  const [key, setKey] = useState(0); // State to force re-render

  const onDragEnd = (result) => {
    try {
      if (!result.destination) return;
      const sourceIndex = result.source.index;
      const destinationIndex = result.destination.index;

      // Get current form values
      const currentFabrics = fabrics;

      // Create new array with reordered items
      const reorderedFabrics = Array.from(currentFabrics);
      const [removed] = reorderedFabrics.splice(sourceIndex, 1);
      reorderedFabrics.splice(destinationIndex, 0, removed);

      // Update order property for each item
      const updatedFabrics = reorderedFabrics.map((fabric, index) => ({
        ...fabric,
        order: index,
      }));

      // Update the form state in a single operation
      setValue("fabrics", updatedFabrics, {
        shouldValidate: true,
        shouldDirty: true,
      });

      // Force re-render by updating the key
      setKey((prevKey) => prevKey + 1);
    } catch (error) {
      console.error("Drag error:", error);
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable
        droppableId="droppable-fabrics"
        direction="vertical"
        ignoreContainerClipping={true}
      >
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} key={key}>
            <div className="grid grid-cols-4 items-start gap-4">
              <FormLabel className="text-right pt-3">Fabric Colors</FormLabel>
              <div className="col-span-3">
                {fabrics?.map((fabric, index) => (
                  <DraggableFabricItem
                    key={fabric.id}
                    index={index}
                    fabric={fabric}
                    control={control}
                    setValue={setValue}
                  />
                ))}
                {provided.placeholder}
              </div>
            </div>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
